import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-admin-wallet',
    templateUrl: './common-admin-wallet.component.html',
    styleUrls: ['./common-admin-wallet.component.scss'],
    standalone: false
})
export class CommonAdminWalletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
